import SecondaryButton from 'components/buttons/v4/SecondaryButton';
import * as Color from 'core/colors';
import * as CommonButton from 'core/v4button';
import React from 'react';
import styled from 'styled-components';

const ButtonElement = styled(SecondaryButton).attrs(
  ({ shape = 'rectangle', context = 'light', size = 'medium', disabled = false }: CommonButton.IButton) => {
    const defaultStyles: any = {
      borderColor: Color.primaryBlack,
      color: Color.primaryBlack,
      backgroundColor: Color.primaryGray
    };
    const attributeStyles: any = {
      ...CommonButton.BaseStyles,
      dark: {
        borderColor: Color.white,
        color: Color.white,
        backgroundColor: Color.primaryBlack
      }
    };
    let stateStyles: any = {};

    return {
      ...defaultStyles,
      ...attributeStyles[shape],
      ...attributeStyles[context],
      ...attributeStyles[size],
      ...stateStyles
    };
  }
)`
  background-color: ${props => props.backgroundColor};
  border-color: ${props => props.borderColor};
  color: ${props => props.color};
`;

function CancelButton({ type = 'button', ...props }: CommonButton.IButton) {
  const { children, click } = props;

  return (
    <ButtonElement type={type} onClick={click} {...props}>
      <span>{children}</span>
    </ButtonElement>
  );
}

export default CancelButton;
